export default "__VITE_ASSET__CZUUCjjS__"